import { FC } from "react";
import { Stack } from "@mui/material";
import { useDidMount } from "rooks";
import { DashboardAllItemsHeader } from "./components/header/DashbaordAllItemsHeader";
import { useAppDispatch } from "@/store/hooks";
import { getDashboardsVisibilityHierarchyThunk } from "@/store/dashboards/thunks/dashboard-hierarchy-visibility/getDashboardsVisibilityHierarchyThunk";
import { DashboardAllItemsAgGrid } from "@/components/pages/dashboard-all-items/components/table/DashboardAllItemsAgGrid";

export const DashboardAllItems: FC = () => {
  const dispatch = useAppDispatch();

  useDidMount(() => {
    dispatch(getDashboardsVisibilityHierarchyThunk());
  });

  return (
    <Stack bgcolor="white" height="100dvh" overflow="hidden">
      <DashboardAllItemsHeader />

      <DashboardAllItemsAgGrid />
    </Stack>
  );
};
